import React, { Component } from 'react';
import {
  View, StyleSheet, FlatList, TouchableOpacity,
  TextInput, Button, Platform, Keyboard, Text
} from 'react-native';
import * as Notifications from 'expo-notifications';
import Color from 'react-native-material-color';
import { connect } from 'react-redux';

import * as actions from '../actions/notifications';
import * as Commons from '../utils/Commons';
import * as Styles from '../utils/Styles';
import { STRINGS } from '../utils/Strings';

import Header from '../components/Header';
let styles = {};

class MyNotifications extends Component {

  async componentDidMount() {
    const language = await Commons.language();
    const fontFamily = language.startsWith('ar') ? 'riposte' : 'riposte';
    const textAlign = language.startsWith('ar') ? 'left' : 'left';
    const fontSize = language.startsWith('ar') ? 13 : 15;
    styles = myStyle({ fontFamily, fontSize, textAlign });
    const notificationList = (await Commons.getNotifcations()).data;
    this.props.updateState({ fontFamily, fontSize, textAlign, notificationList });
    Commons.clearNotifications();
  }

  renderHeader() {
    if (this.orderModal !== undefined && this.orderModal.state.isOpen) {
      return <Header  navigation={this.props.navigation} title={STRINGS.company_name} leftView={Styles.backButton(this.orderModal)} light />;
    }
    return <Header  navigation={this.props.navigation} title={STRINGS.company_name} leftView={Styles.drawerButton(this.props.navigation)} />;
  }
  render() {
    return (
      <View style={styles.container}>
        {this.renderHeader()}
        {Styles.renderVSeparator(Commons.isIphoneX && Commons.isIphoneX() ? 80 : Platform.select({ ios: 68, android: 68 }))}
        <FlatList
          contentContainerStyle={styles.flatlist}
          data={this.props.notificationList !== null ? this.props.notificationList : []}
          renderItem={this.renderItem}
          keyExtractor={(item, index) => index}
          showsVerticalScrollIndicator={false}
          keyboardShouldPersistTaps={'always'}
          onRefresh={() => {
            // const notificationList = (await Commons.getNotifcations()).data;
            // this.props.updateState({ fontFamily, fontSize, textAlign, notificationList });
          }}
          removeClippedSubviews
          refreshing={false}
        />
        {/* Error View */}
        {this.props.orders === null && Commons.renderErrorView(() => {

        })}
      </View>
    );
  }

  renderItem = ({ item }) =>
    <TouchableOpacity
      style={[styles.card, STRINGS.isArLtrOrEnRtl && { alignItems: 'flex-start' }, { elevation: 0 }]}
    >
      <Text style={styles.status}>
        <Text style={{ color: '#ed9c26', fontSize: 14, fontFamily: this.props.fontFamily }}>{item.TITLE} </Text>
        {/* <Text style={{ color: '#ed9c26', fontSize: 12, fontFamily: 'riposte' }}>{`${item.time}`}</Text> */}
      </Text>
      <Text>
        <Text style={styles.text}>{item.MSG} </Text>
      </Text>
    </TouchableOpacity>
}

const myStyle = props => ({
  container: {
    flex: 1,
    backgroundColor: '#b8b05e'
  },
  flatlist: {
    padding: 12
  },
  card: {
    padding: 8,
    alignItems: 'flex-start',
    elevation: 4,
    backgroundColor: 'white',
    marginBottom: 5,
    ...Styles.border
  },
  status: {
    color: '#ed9c26',
    fontSize: 18
  },
  ratingInput: {
    height: 140,
    textAlignVertical: 'top',
    marginTop: 12,
    width: Styles.modal.width - 24,
    marginBottom: 12,
    padding: 8,
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: Color.GREY[500],
    backgroundColor: 'white',
    borderRadius: 4,
    textAlign: Styles.isLtr() ? 'left' : 'left',
    fontSize: 16,
    color: 'black'
  },
  text: {
    fontSize: 14,
    fontFamily: props.fontFamily,
    color: '#6b3529'
  },
  text2: {
    fontSize: 18,
    fontFamily: 'zarid',
    color: '#6b3529',
    lineHeight: 22
  }
});

const mapStateToProps = ({ notifications }) => notifications;

export default connect(
  mapStateToProps,
  actions
)(MyNotifications);
